import styled, { css } from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import getBackgroundColor from 'gatsby-theme-pagebuilder/src/components/get-background-color';
import Children from 'gatsby-theme-menus/src/components/nav/list-nav/children';

export default styled(Children)`
  ${({ $hasColumn }) => $hasColumn && css`
    padding: 0;
    right: 0;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 10px 0px, rgba(0, 0, 0, 0.5) 0px 9999px 0px 9999px;
    background-color: white;

    ${Container} {
      display: grid;
      grid-template-columns: 1fr 3fr;
      > *:first-child { // the column
        grid-column: 1; // override the default column settings
        > *:first-child { // its background
          padding: 3rem 3rem 3rem 0; // create a card
        }
        // make sure the color overflows
        position: relative;
        &::before {
          content: " ";
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          width: 9999px;
          z-index: -1;
          ${({
    $columnBackgroundColor,
    $columnBackgroundCustomColor,
    theme,
  }) => $columnBackgroundColor && getBackgroundColor(theme, $columnBackgroundColor, $columnBackgroundCustomColor)}
        }
      }
      > *:last-child { // the subitems
        padding: 3rem;
      }
    }
  `}
`;
